import { render, staticRenderFns } from "./DemoForm.vue?vue&type=template&id=1dcfcd38&scoped=true"
import script from "./DemoForm.vue?vue&type=script&lang=js"
export * from "./DemoForm.vue?vue&type=script&lang=js"
import style0 from "./DemoForm.vue?vue&type=style&index=0&id=1dcfcd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcfcd38",
  null
  
)

export default component.exports